import { Flex, Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { ReactNode } from "react";

export const messageToastLogin = (
  message?: string,
  navigateForgotPassword: () => void = () => {},
  navigateFirstLogin: () => void = () => {},
): ReactNode => {
  const normalizedMessage = message?.trim().toLowerCase();

  const HelpLink = () => (
    <Text
      as={Link}
      to="/needHelp"
      color="white"
      textDecoration="underline"
      cursor="pointer"
      w="fit-content"
    >
      Precisa de ajuda?
    </Text>
  );

  const ForgotPasswordLink = () => (
    <Text
      as="span"
      color="white"
      textDecoration="underline"
      cursor="pointer"
      w="fit-content"
      onClick={navigateForgotPassword}
    >
      Esqueceu sua senha.
    </Text>
  );

  if (!normalizedMessage) {
    return (
      <Text color="white">
        Caso não lembre seus dados ou tenha alguma dúvida entre em contato pelo{" "}
        <HelpLink />
      </Text>
    );
  }

  if (
    normalizedMessage.includes("verifique email e senha") ||
    normalizedMessage.includes("não lembre seus dados de acesso")
  ) {
    return (
      <Flex direction="column" lineHeight="5">
        Caso tenha esquecido seus dados de acesso, clique no link{" "}
        <ForgotPasswordLink />
      </Flex>
    );
  }

  if (
    normalizedMessage.includes("erro interno ao autenticar") ||
    normalizedMessage.includes("não está autorizado")
  ) {
    return (
      <Flex direction="column" lineHeight="5">
        {message}
      </Flex>
    );
  }

  if (normalizedMessage.includes("fazer parte do time de vendas")) {
    return (
      <Flex direction="column" lineHeight="5">
        <Text>
          Se deseja fazer parte do time de vendas, entre em contato pelo link{" "}
          <HelpLink />
        </Text>
      </Flex>
    );
  }

  if (
    normalizedMessage.includes(
      "seus dados cadastrais foram atualizados no nosso sistema",
    )
  ) {
    return (
      <Flex direction="column" lineHeight="5">
        Seus dados cadastrais foram atualizados no nosso sistema. Por isso, será
        necessário que você clique no link{" "}
        <Text
          as="span"
          color="white"
          textDecoration="underline"
          cursor="pointer"
          w="fit-content"
          onClick={navigateFirstLogin}
        >
          Primeiro acesso.
        </Text>
      </Flex>
    );
  }

  return <Text color="white">{message}</Text>;
};
